const classes = Object.freeze({
    paper: 'll-select__paper',
    list: 'll-select__list'
});

export {
    classes,
};